var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_123776)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1928_123776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.167,
    y: -1,
    width: 51.89,
    height: 34.515,
    rx: 6.48545,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.723 -1H-11.167V33.515H40.723V-1Z",
    fill: "#B31942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.167 2.98241H40.723ZM40.723 8.29241H-11.167ZM-11.167 13.6024H40.723ZM40.723 18.9124H-11.167ZM-11.167 24.2224H40.723ZM40.723 29.5324H-11.167Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.167 2.98241H40.723M40.723 8.29241H-11.167M-11.167 13.6024H40.723M40.723 18.9124H-11.167M-11.167 24.2224H40.723M40.723 29.5324H-11.167",
    stroke: "white",
    strokeWidth: 2.655
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0645 -1H-11.167V17.585H15.0645V-1Z",
    fill: "#0A3161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.238022 -0.203934L0.386208 1.71724L-1.24805 0.529891H0.772003L-0.862252 1.71724L-0.238022 -0.203934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.238022 3.51318L0.386208 5.43436L-1.24805 4.24701H0.772003L-0.862252 5.43436L-0.238022 3.51318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.238022 7.23163L0.386208 9.15281L-1.24805 7.96545H0.772003L-0.862252 9.15281L-0.238022 7.23163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.238022 10.9473L0.386208 12.8685L-1.24805 11.6811H0.772003L-0.862252 12.8685L-0.238022 10.9473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.238022 14.6646L0.386208 16.5857L-1.24805 15.3984H0.772003L-0.862252 16.5857L-0.238022 14.6646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9485 1.65515L2.57273 3.57633L0.938477 2.38898H2.95853L1.32427 3.57633L1.9485 1.65515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9485 5.3718L2.57273 7.29297L0.938477 6.10562H2.95853L1.32427 7.29297L1.9485 5.3718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9485 9.08952L2.57273 11.0107L0.938477 9.82335H2.95853L1.32427 11.0107L1.9485 9.08952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9485 12.8057L2.57273 14.7269L0.938477 13.5395H2.95853L1.32427 14.7269L1.9485 12.8057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13405 -0.203964L4.75828 1.71721L3.12402 0.52986H5.14407L3.50982 1.71721L4.13405 -0.203964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13405 3.51398L4.75828 5.43515L3.12402 4.2478H5.14407L3.50982 5.43515L4.13405 3.51398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13405 7.23244L4.75828 9.15361L3.12402 7.96626H5.14407L3.50982 9.15361L4.13405 7.23244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13405 10.9466L4.75828 12.8678L3.12402 11.6804H5.14407L3.50982 12.8678L4.13405 10.9466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13405 14.6653L4.75828 16.5865L3.12402 15.3992H5.14407L3.50982 16.5865L4.13405 14.6653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3196 1.65434L6.94383 3.57552L5.30957 2.38817H7.32962L5.69537 3.57552L6.3196 1.65434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3196 5.37251L6.94383 7.29369L5.30957 6.10634H7.32962L5.69537 7.29369L6.3196 5.37251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3196 9.08832L6.94383 11.0095L5.30957 9.82214H7.32962L5.69537 11.0095L6.3196 9.08832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3196 12.8063L6.94383 14.7275L5.30957 13.5401H7.32962L5.69537 14.7275L6.3196 12.8063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50612 -0.204041L9.13035 1.71714L7.49609 0.529784H9.51614L7.88189 1.71714L8.50612 -0.204041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50612 3.51396L9.13035 5.43514L7.49609 4.24779H9.51614L7.88189 5.43514L8.50612 3.51396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50612 7.22993L9.13035 9.15111L7.49609 7.96376H9.51614L7.88189 9.15111L8.50612 7.22993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50612 10.9493L9.13035 12.8705L7.49609 11.6831H9.51614L7.88189 12.8705L8.50612 10.9493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50807 14.6645L9.1323 16.5857L7.49805 15.3984H9.5181L7.88384 16.5857L8.50807 14.6645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6936 1.65674L11.3178 3.57792L9.68359 2.39056H11.7036L10.0694 3.57792L10.6936 1.65674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6936 5.37471L11.3178 7.29589L9.68359 6.10853H11.7036L10.0694 7.29589L10.6936 5.37471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6936 9.09082L11.3178 11.012L9.68359 9.82464H11.7036L10.0694 11.012L10.6936 9.09082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6936 12.8088L11.3178 14.73L9.68359 13.5426H11.7036L10.0694 14.73L10.6936 12.8088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8792 -0.202835L13.5034 1.71834L11.8691 0.530989H13.8892L12.2549 1.71834L12.8792 -0.202835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8792 3.51358L13.5034 5.43476L11.8691 4.2474H13.8892L12.2549 5.43476L12.8792 3.51358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8792 7.23212L13.5034 9.15329L11.8691 7.96594H13.8892L12.2549 9.15329L12.8792 7.23212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8792 10.9478L13.5034 12.8689L11.8691 11.6816H13.8892L12.2549 12.8689L12.8792 10.9478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8792 14.6661L13.5034 16.5873L11.8691 15.3999H13.8892L12.2549 16.5873L12.8792 14.6661Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_123776"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1928_123776"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.167,
    y: -1,
    width: 51.89,
    height: 34.515,
    rx: 6.48545,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.7fbb758bd0b82cc16a59a7c8a21fa7d0.svg";
export { ForwardRef as ReactComponent };